import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../../services/ApiService'
import { showAlert } from '../../../utility/SweetAlert'

const InteractorMasterSubdistrictView = () => {
  const { t } = useTranslation()

  const subdistrictView = useCallback(
    (uid, callback, loading) => {
      const payload = {
        uid,
      }
      ApiService.jsonRequest('/master-subdistrict/view', payload, response => {
        if (response.status_code === 200) {
          callback(response.data)
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: 1500,
          })
        }
        loading(false)
      })
    },
    [t],
  )

  return { subdistrictView }
}

export default InteractorMasterSubdistrictView
